// extracted by mini-css-extract-plugin
export default {"item":"faqItem_item__whmNb","header":"faqItem_header__yC0Fn","title":"faqItem_title__rTl1L","content":"faqItem_content__hHkIf","arrow":"faqItem_arrow__KFp3X"};